<app-header></app-header>

<!-- Face extract / search prep loader (same scan UI as face1 results) -->
<app-image-scan-loader
  *ngIf="isExtractingFaces || isStartingSearch"
  [imageSrc]="(isStartingSearch ? selectedImageDetails?.thumbnail : imagePreview) || ''"
  [percentageComplete]="isStartingSearch ? 'Starting search...' : 'Detecting faces...'">
</app-image-scan-loader>

<div class="main-container d-flex">
    <app-sidebar></app-sidebar>
    <div class="container-fluid h-100p overflow-y-scroll image-search-main px-2 px-sm-3 px-lg-4">
        <app-face-search-tabs activeTab="reverse-search">
            <div class="credits-display">
                <div class="credits-inline">
                    <span class="credits-inline-label">Remaining:</span>
                    <span class="credits-inline-value"><i class="fas fa-spinner fa-spin" *ngIf="creditsLoading" aria-hidden="true"></i><ng-container *ngIf="!creditsLoading">{{ availableCredits | creditsLabel }}</ng-container></span>
                </div>
                <button class="buy-credits-btn" (click)="onBuyCreditsButtonClick()">
                    <i class="fas fa-coins credits-icon"></i>
                    Buy Credits
                </button>
            </div>
        </app-face-search-tabs>
        <div class="top-section">
            <div class="search-card-container" *ngIf="isServiceDisabled">
                <div class="service-disabled-warning">
                    <div class="warning-icon">
                        <i class="fas fa-exclamation-triangle"></i>
                    </div>
                    <h2 class="warning-title">Search temporarily unavailable</h2>
                    <p class="warning-message">
                        We're experiencing a temporary service issue. You can still access and export your previous search history below.
                    </p>
                </div>
            </div>

            <div class="search-card-container" *ngIf="!isServiceDisabled">
                <div class="search-card">
                    <h2 class="search-title">
                        <i class="fas fa-camera"></i>
                        Search by Face
                    </h2>

                    <p class="search-card-subtitle">
                        Upload a clear face image or paste a public URL.
                    </p>

                    <!-- Restricted access banner temporarily disabled
                    <div class="restricted-alert" appRestrictedAccessWarning>
                        <i class="fas fa-exclamation-circle alert-icon"></i>
                        <span class="alert-text">
                            <span class="alert-restricted">RESTRICTED ACCESS</span>
                            <span class="alert-authorized">Authorized Law Enforcement Use Only</span>
                        </span>
                    </div>
                    -->

                    <p class="credit-cost-notice" *ngIf="searchCreditCost != null">
                        Each search costs <strong>{{ searchCreditCost }}</strong>
                        {{ searchCreditCost === 1 ? 'credit' : 'credits' }}. If no results are found credits will be refunded.
                    </p>

                    <ng-container *ngIf="!imagePreview">
                        <div class="image-upload-zone" [class.drag-over]="isDraggingOver" (dragover)="onDragOver($event)" (dragleave)="onDragLeave($event)" (drop)="onDrop($event)">
                            <div class="upload-icon-shell">
                                <i class="fas fa-cloud-upload-alt"></i>
                            </div>
                            <p class="upload-text">Drop image of the person you want to find</p>
                            <p class="upload-hint">PNG · JPG · WEBP up to 10 MB</p>
                            <label class="upload-btn">
                                <input hidden type="file" (change)="onImageSelected($event)" accept="image/*" />
                                <span><i class="fas fa-image"></i> Upload an Image</span>
                            </label>

                            <div class="upload-divider"><span>OR</span></div>

                            <div class="url-search-row" (click)="$event.stopPropagation()" (dragover)="$event.stopPropagation()">
                                <div class="url-field-shell">
                                    <span class="url-tag"><i class="fas fa-link"></i> URL</span>
                                    <input type="text" placeholder="Paste a public image URL" [(ngModel)]="imageUrl" />
                                </div>
                                <button class="search-btn" (click)="onUrlSearch()">
                                    <i class="fas fa-search"></i>
                                    Search
                                </button>
                            </div>
                        </div>
                    </ng-container>

                    <div class="preview-section" *ngIf="imagePreview">
                        <div class="preview-box modern-preview-box">
                            <div class="uploaded-preview-card">
                                <div class="uploaded-preview-thumb-wrap">
                                    <img class="uploaded-img" [src]="imagePreview" alt="Uploaded Image" />
                                </div>
                                <div class="uploaded-preview-meta">
                                    <p class="upload-ready-label">IMAGE READY</p>
                                    <h4 class="upload-file-name">{{ uploadedFileName || 'uploaded-image' }}</h4>
                                    <p class="upload-file-size">{{ uploadedFileSizeText || 'Ready to process' }}</p>
                                    <div class="uploaded-preview-actions">
                                        <label class="replace-image-btn">
                                            <input hidden type="file" (change)="onImageSelected($event)" accept="image/*" />
                                            <span><i class="far fa-image"></i> Replace</span>
                                        </label>
                                        <button class="remove-image-btn" (click)="removeImage()">
                                            <i class="fas fa-times"></i>
                                            Remove
                                        </button>
                                    </div>
                                </div>
                            </div>
                            <p class="preview-text">Image ready. Proceed to detect faces before searching.</p>
                            <button class="start-btn" (click)="extractFaces()" [disabled]="isExtractingFaces">
                                <span *ngIf="!isExtractingFaces">Start Facial Recognition</span>
                                <span *ngIf="isExtractingFaces" class="btn-loading-content">
                                    <span class="spinner"></span>
                                    Processing...
                                </span>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="results-section">
            <div class="results-header">
                <h3 class="results-title">Recent Image Searches</h3>
                <p class="results-subtitle">Showing only your face searches. Click any row to reopen the report.</p>
            </div>
            <div class="results-body">
                <div class="results-controls">
                    <div class="filter-section">
                        <select class="filter-select" [(ngModel)]="selectedFilterType" (ngModelChange)="onFilterTypeChange()">
                            <option *ngFor="let filterType of filterTypes" [value]="filterType.value">
                                {{ filterType.label }}
                            </option>
                        </select>
                        <div class="filter-input-container">
                            <input *ngIf="selectedFilterType === 'search-name'" class="filter-input" type="text" placeholder="Search by content" [(ngModel)]="searchNameFilter" (ngModelChange)="onSearchNameFilterChange($event)">
                            <input *ngIf="selectedFilterType === 'notes'" class="filter-input" type="text" placeholder="Search by content" [(ngModel)]="notesFilter" (ngModelChange)="onNotesFilterChange($event)">
                            <div class="date-filter-group" *ngIf="selectedFilterType === 'date-added'">
                                <input class="filter-input date-input" type="date" [(ngModel)]="startDateFilter" (ngModelChange)="onStartDateFilterChange($event)">
                                <input class="filter-input date-input" type="date" [(ngModel)]="endDateFilter" (ngModelChange)="onEndDateFilterChange($event)">
                            </div>
                        </div>
                    </div>

                    <div class="action-buttons">
                        <div class="dropdown export-dropdown">
                            <button type="button" class="action-btn export-btn dropdown-toggle" data-bs-toggle="dropdown" aria-expanded="false">
                                <i class="fas fa-download" aria-hidden="true"></i>
                                Export
                            </button>
                            <ul class="dropdown-menu export-dropdown-menu">
                                <li>
                                    <button type="button" class="dropdown-item" (click)="onExportExcelButtonClick()">
                                        <i class="fas fa-file-excel" aria-hidden="true"></i>
                                        Export Excel
                                    </button>
                                </li>
                                <li>
                                    <button type="button" class="dropdown-item" (click)="onExportCsvButtonClick()">
                                        <i class="fas fa-file-csv" aria-hidden="true"></i>
                                        Export CSV
                                    </button>
                                </li>
                                <li>
                                    <button type="button" class="dropdown-item" (click)="onExportPdfButtonClick()">
                                        <i class="fas fa-file-pdf" aria-hidden="true"></i>
                                        Export PDF
                                    </button>
                                </li>
                            </ul>
                        </div>
                        <button class="action-btn delete-btn" (click)="onDeleteButtonClick()">
                            <i class="fas fa-trash"></i>
                            Delete
                        </button>
                    </div>
                </div>

                <div class="loading-container" *ngIf="loadingRecentResults">
                    <div class="spinner-border" role="status"></div>
                    <p class="loading-text">Fetching results, please wait...</p>
                </div>

                <div class="results-table-container">
                    <table class="results-table">
                        <colgroup>
                            <col class="col-checkbox">
                            <col class="col-image">
                            <col class="col-name">
                            <col class="col-status">
                            <col class="col-date">
                            <col class="col-time">
                            <col class="col-notes">
                        </colgroup>
                        <thead>
                            <tr>
                                <th class="checkbox-column">
                                    <input type="checkbox" class="table-checkbox" [checked]="recentResultsSelectAll.isSelected" (change)="onRecentResultsSelectAllClick()">
                                </th>
                                <th>Image</th>
                                <th>Search</th>
                                <th>Status</th>
                                <th>Date Added</th>
                                <th>Time</th>
                                <th>Notes</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngIf="!loadingRecentResults && (!recentResultsPaged?.length || recentResultsCount === 0)" class="no-data-row">
                                <td colspan="7" class="no-data-cell">No results yet. Search using the input above</td>
                            </tr>
                            <tr *ngFor="let recentResultPaged of recentResultsPaged" class="table-row">
                                <td class="checkbox-column">
                                    <input type="checkbox" class="table-checkbox" [checked]="recentResultPaged.isSelected" (click)="onRecentResultPagedClick($event, recentResultPaged)">
                                </td>
                                <td class="image-column" (click)="goToSearchResultPage(recentResultPaged)">
                                    <img class="history-thumb" [src]="recentResultPaged.thumbnail || 'assets/icons/mouse-square.png'" [alt]="getHistorySearchLabel(recentResultPaged)" />
                                </td>
                                <td class="name-column" [title]="getHistorySearchLabel(recentResultPaged)" (click)="goToSearchResultPage(recentResultPaged)">
                                    {{ getHistorySearchLabel(recentResultPaged) }}
                                </td>
                                <td class="status-column">
                                    <span class="status-badge" [class.status-completed]="isHistoryCompleted(recentResultPaged)" [class.status-pending]="!isHistoryCompleted(recentResultPaged)">
                                        {{ isHistoryCompleted(recentResultPaged) ? 'Completed' : 'Pending' }}
                                    </span>
                                </td>
                                <td class="date-column">
                                    {{ recentResultPaged.created_on | date : 'MMM d, y' }}
                                </td>
                                <td class="time-column">
                                    {{ recentResultPaged.created_on | date : 'HH:mm:ss' }}
                                </td>
                                <td class="notes-column" [title]="getHistoryNotesLabel(recentResultPaged)">{{ truncateToWords(getHistoryNotesLabel(recentResultPaged)) || '—' }}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>

                <div class="pagination-container">
                    <div class="pagination-info">
                        Showing {{ recentResultsPagedStartAndEnd.start }} of {{ recentResultsCount }} result
                    </div>
                    <div class="pagination-controls">
                        <app-paginator [totalItems]="recentResultsCount" [itemsPerPage]="recentResultsPerPage" [currentPage]="recentResultsCurrentPage" (pageChange)="onRecentResultsPageChange($event)">
                        </app-paginator>
                    </div>
                </div>
            </div>
        </div>

        <!-- Face selection dialogue -->
        <div class="side-dialog-overlay" *ngIf="showDialog" (click)="closeDialog()"></div>
        <div class="side-dialog" *ngIf="showDialog">
            <button class="floating-close-btn" (click)="closeDialog()">
                ×
            </button>
            <div class="card">
                <div class="card-section">
                    <ng-container>
                        <div class="side-dialog-header">
                            <img src="assets/icons/mouse-square.png" alt="icon" class="title-icon" />
                            <h4 class="mb-0">Choose Image</h4>
                        </div>
                        <div class="side-dialog-body">
                            <div class="image-box" [class.selected]="selectedImageIndex === i" *ngFor="let extractedImage of extractedImages; let i = index" (click)="selectExtractedImage(i)">
                                <img class="grid-img" [src]="extractedImage?.thumbnail" [style.transform]="(selectedImageIndex === i && isImageMirrored) ? 'scaleX(-1)' : 'scaleX(1)'" alt="photo" />
                            </div>
                        </div>
                        <div class="mirror-checkbox-wrapper">
                            <label class="mirror-checkbox-label">
                                <input type="checkbox" [(ngModel)]="isImageMirrored" [disabled]="selectedImageIndex === null" />
                                <span>Mirror Image</span>
                            </label>
                        </div>
                        <button class="search-face-btn" [disabled]="selectedImageIndex === null" (click)="onSearchFaceClick()">
                            Search face on Internet
                        </button>
                    </ng-container>
                </div>
            </div>
        </div>
    </div>
</div>